import { getFunctions, httpsCallable } from "firebase/functions";
import { app } from "./config";

const functions = getFunctions(app);

export const getPromoterAccessV2 = httpsCallable(functions, "getPromoterAccessV2");

export { getFunctions, httpsCallable };

export const updateGoogleCalendarEvent = httpsCallable(functions, "updateGoogleCalendarEvent");
export const triggerRescheduleWebhook = httpsCallable(functions, "triggerRescheduleWebhook");
export const deleteGoogleCalendarEvent = httpsCallable(functions, "deleteGoogleCalendarEvent");
export const triggerCancelWebhook = httpsCallable(functions, "triggerCancelWebhook");
export const refreshSquareToken = httpsCallable(functions, "refreshSquareToken");
export const zapierGenerateSession = httpsCallable(functions, "zapierGenerateSession");
export const googleAnalyticsAuthRequest = httpsCallable(functions, "googleAnalyticsAuthRequest");
export const dialpadAuthURL = httpsCallable(functions, "dialpadAuthURL");
export const dialpadRevoke = httpsCallable(functions, "dialpadRevoke");
export const dialpadAuthRequest = httpsCallable(functions, "dialpadAuthRequest");
export const googleCalendarAuthURL = httpsCallable(functions, "googleCalendarAuthURL");
export const googleCalendarRevoke = httpsCallable(functions, "googleCalendarRevoke");
export const googleCalendarAuthRequest = httpsCallable(functions, "googleCalendarAuthRequest");
export const squareAuthRequest = httpsCallable(functions, "squareAuthRequest");
export const enrollCurrentUserLifecycleV2 = httpsCallable(functions, "enrollCurrentUserLifecycleV2");

export const notifyBookingCancellation = httpsCallable(functions, "notifyBookingCancellation");
